
<ng-template [ngIf]="isCreatingOda">
      <app-loading></app-loading>
</ng-template>
    <div class="d-flex mt-2">
            <form [formGroup]="creaOdaForm">
                <div class="grid formgrid p-fluid">
                    <div class="field mt-2 mb-2 col-6">
                        <label for="azienda" class="font-medium text-900 text-green-900">IMPRESA</label>
                        <span class="p-input-icon-left">
                            <p-dropdown inputId="azienda" [options]="aziende" optionLabel="ragioneSociale" [showClear]="true"
                                placeholder="Scegli l'impresa" formControlName="azienda"
                                (onChange)="onAziendaSelection($event)">
                                <ng-template let-azienda pTemplate="item">
                                    <p-tag
                                        [value]="azienda.ragioneSociale | uppercase"
                                        [style]="{
                                        'background-color': '#326F6F' ,
                                        'color': '#ffffff' ,
                                        'border-radius': '6px',
                                        'padding': '.25em .5rem',
                                        'font-weight': '700',
                                        'font-size': '13px',
                                        'letter-spacing': '.3px;',
                                        'cursor': 'pointer',
                                        }"
                                    ></p-tag>
                                   <!--  <div class="flex align-items-center">
                                        <div>{{azienda.ragioneSociale | uppercase}}</div>
                                    </div> -->
                                </ng-template>
                            </p-dropdown>
                        </span>
                    </div>
                    <div class="field mt-2 mb-2 col-3">
                        <label for="bando" class="font-medium text-900 text-blue-900">BANDO</label>
                        <span class="p-input-icon-left" >
                          
                            <p-dropdown inputId="bando" [options]="bandi" optionLabel="denominazione" [showClear]="true"
                                placeholder="Scegli il bando" formControlName="bando"
                                (onChange)="onBandoSelection($event)">
                                <ng-template let-bando pTemplate="item">
                                    <p-tag
                                        [value]="bando.denominazione | uppercase"
                                        [style]="{
                                            'background-color': bando.denominazione==='BANDO 1'?'cadetblue':'cornflowerblue' ,
                                            'color': '#ffffff' ,
                                            'border-radius': '6px',
                                            'padding': '.25em .5rem',
                                            'font-weight': '700',
                                            'font-size': '13px',
                                            'letter-spacing': '.3px;',
                                            'cursor': 'pointer',
                                        }"
                                    ></p-tag>
                                    <!-- <div class="flex align-items-center">
                                        <div>{{bandi.denominazione | uppercase}}</div>
                                    </div> -->
                                </ng-template>
                            </p-dropdown>
                        </span>
                    </div>
                    <div class="field mt-2 mb-2 col-3">
                        <label for="lotti" class="font-medium text-900 text-blue-900">LOTTI</label>
                        <span class="p-input-icon-left" >
                            <p-multiSelect 
                            inputId="lotti" 
                            [options]="lotti" 
                            [showClear]="true"
                            [filter]="false"
                            [selectedItemsLabel]="'TUTTI'" 
                            placeholder="Scegli i lotti" 
                            formControlName="lotti">
                            <ng-template let-lotto pTemplate="item">
                                <div class="flex align-items-center">
                                    <div>{{lotto | uppercase}}</div>
                                </div>
                            </ng-template>
                        </p-multiSelect>
                        </span>
                    </div>
                    <div class="field mt-2 mb-2 col-3">
                        <label for="numero" class="font-medium text-900 text-blue-600">NUMERO</label>
                        <p-inputNumber inputId="numero" formControlName="numero" [styleClass]="'right-align'" [useGrouping]="false"
                        (onBlur)="checkNumero($event)"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-3">
                        <label for="importo" class="font-medium text-900 text-green-600">IMPORTO</label>
                        <p-inputNumber mode="currency" maxFractionDigits="2"
                            inputId="importo" 
                            currency="EUR" locale="it-IT" 
                            formControlName="importo" 
                            [styleClass]="'right-align'"> 
                        </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-6">
                        <label for="referenteTim" class="font-medium text-900 text-gray-600">REFERENTE TIM</label>
                        <input type="text" pInputText formControlName="referenteTim" />
                    </div>
                   <!--  
                   
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita3" class="font-medium text-900 text-blue-600">SCL.3</label>
                        <p-inputNumber mode="currency" inputId="ita3" currency="EUR" locale="it-IT" formControlName="ita3" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita4" class="font-medium text-900 text-blue-600">SCL.4</label>
                        <p-inputNumber mode="currency" inputId="ita4" currency="EUR" locale="it-IT" formControlName="ita4" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="ita5" class="font-medium text-900 text-blue-600">SCL.5</label>
                        <p-inputNumber mode="currency" inputId="ita5" currency="EUR" locale="it-IT" formControlName="ita5" [styleClass]="'right-align'"> </p-inputNumber>
                    </div>
                    <div class="field mt-2 mb-2 col-2">
                        <label for="preventivoBaseItalia" class="font-medium text-900 text-blue-600">Preventivo Base</label>
                        <p-inputNumber mode="currency" inputId="preventivoBaseItalia" currency="EUR" locale="it-IT" formControlName="preventivoBaseItalia" [styleClass]="'right-align'"> </p-inputNumber>
                    </div> -->
                </div> 
            </form>
         
        
    </div>




<div class="surface-border border-top-1 opacity-50 mb-3 col-12"></div>
<div class="margin-top-1" style="text-align: center; display: flex; justify-content: center; align-items: center;">
    <p-button icon="pi pi-times" (onClick)="conferma(false)" label="Annulla" class="p-button-text mr-2"
    styleClass="p-button-warning"></p-button>
   <p-button  icon="pi pi-check" label="Conferma"
        class="p-button-text ml-100" styleClass="p-button-success" (click)="conferma(true)" [disabled]="isCreatingOda || !creaOdaForm.valid"></p-button>
</div>
<p-toast />
